<script lang="ts">
import { h, ref, watch } from 'vue';

export default {
  props: {
    needToStop: {
      type: Boolean,
    },
    timeouts: {
      default: [],
      type: Array<number>
    }
  },
  emits: ['stop'],
  setup: (props, { emit, slots }) => {
    const currentValue = ref(0);

    // const slots = useSlots();
    let needToStop = false;

    /*  */
    // const t1 = performance.now();
    const createTimeout = (ms: number) => {
      setTimeout(() => {
        ++currentValue.value;
        // console.log('DONE', performance.now() - t1);
      }, ms);
    };

    /*  */
    watch(currentValue, (val) => {
      if (needToStop) return;

      const timeout = props.timeouts[val];
      if (!timeout) return;
      createTimeout(timeout);
    });

    /*  */
    watch(() => props.needToStop, (v) => {
      if (!v) return;

      needToStop = true;
      emit('stop');
    });

    /*  */
    const timeout = props.timeouts[0];
    if (timeout) {
      createTimeout(timeout);
    }

    /* Render */
    return () => h('div', [slots.default?.()[currentValue.value]])
  }
}
</script>

<style scoped></style>
